import { useCallback, useEffect, useMemo, useState } from "react";
import { http } from "../../lib/api";

// Hakediş faturaları (/claims/history): gruplu tabloda "Faturaya Git" için; params değişince yeniden yüklenir, reload ile elle tazelenir
export function useClaimInvoices(params) {
  const [invoices, setInvoices] = useState([]);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => {
    const p = JSON.parse(key);
    if (!p.direction) return;
    http.get("/claims/history", { params: p }).then((r) => setInvoices(r.data)).catch(() => setInvoices([]));
  }, [key]);
  useEffect(() => { reload(); }, [reload]);
  return useMemo(() => [invoices, reload], [invoices, reload]);
}

// Grup (dönem + proje + ana hizmet) ile eşleşen hakediş faturaları; "TÜM HİZMETLER" faturası her ana hizmetle eşleşir
export const invoicesForGroup = (invoices, g) =>
  invoices.filter((inv) => inv.period === g.period && (!inv.project_id || !g.project_id || inv.project_id === g.project_id) && (!inv.category_id || inv.category_id === g.category_id));
